import { Layout, Select } from 'antd';
import { Content, Header } from 'antd/es/layout/layout';
import { useEffect, useState } from 'react';
import { NamespacedCCParts } from '../../apis/mgmt/api';
import { ListProps } from '../common/List';
import { NamespacedCCPartsForm } from './NamespacedCCPartsForm';

export const NamespacedCCPartsListForm = (
    props: ListProps<NamespacedCCParts>
) => {

    const getTabStyle = (tab: string | undefined) => selectedNamespace === tab ? {} : { 'display': 'none' };
    const [selectedNamespace, setSelectedNamespace] = useState<string>();
    useEffect(() => { 
        if (!props.data || props.data.length<=0) return;
        const namespaces = props.data.map((namespacedParts: NamespacedCCParts) => namespacedParts.namespace);
        if (!selectedNamespace || !namespaces.includes(selectedNamespace)) {
            setSelectedNamespace(props.data[0].namespace);
        }
    }, [props.data]);

    return (
        <Layout className="h-100" >
            <Header style={{ 'paddingBottom': '1em' }}>
                <Select onChange={(value: string) => setSelectedNamespace(value)} value={selectedNamespace} style={{ width: '20em' }}>
                    {props.data?.map((namespacedParts: NamespacedCCParts) => (
                        <Select.Option key={namespacedParts.namespace} value={namespacedParts.namespace}>{namespacedParts.namespace}</Select.Option>
                    ))}
                </Select>
            </Header>
            <Content className="h-100">
                {props.data?.map((namespacedParts: NamespacedCCParts) => (
                    <div key={namespacedParts.namespace} className="h-100" style={getTabStyle(namespacedParts.namespace)}>
                        <NamespacedCCPartsForm key={namespacedParts.namespace} 
                            data={namespacedParts} 
                            setData={(data) => props.setItemOrDeleteOld(data, namespacedParts)}
                        />
                    </div>
                ))}
            </Content>
        </Layout>
    );

};
